// extracted by mini-css-extract-plugin
module.exports = {"loader":"Search_loader__IUxk4","shortcut":"Search_shortcut__EUdSr","doSearch":"Search_doSearch___Rx3D","noResults":"Search_noResults__HbLMS"};